/* ============================================================
   BABY BONDÉ — interactive scripts
   ============================================================ */

(function () {
  'use strict';

  /* ---------------- Cart state (durable goods, no subscription) ---------------- */
  const cartState = {
    items: [],
    currency: 'AUD',
    freeShipMin: 80,
  };

  const PRODUCT = {
    id: 'bonding-carrier',
    name: 'The Bonding Carrier',
    price: 79,
    variants: [
      { id: 'beige', name: 'Beige Houndstooth', swatch: '#C7B299' },
      { id: 'black', name: 'Black Houndstooth', swatch: '#1A1816' },
      { id: 'denim', name: 'Denim Cloud', swatch: '#7A8FA8' },
      { id: 'cotton', name: 'Cotton Cloud', swatch: '#E8E2D2' },
    ],
  };

  const UPSELLS = [
    { id: 'pacifier-clip', name: 'Houndstooth Pacifier Clip', price: 18, img: 'assets/img/pacifier-clip.jpg' },
    { id: 'drool-pad', name: 'Drool Pad Set', price: 14, img: null },
    { id: 'fit-guide', name: 'Pediatric Fit Guide', price: 0, img: null },
  ];

  /* ---------------- Helpers ---------------- */
  function $(s, el) { return (el || document).querySelector(s); }
  function $$(s, el) { return Array.from((el || document).querySelectorAll(s)); }
  function money(n) { return '$' + n.toFixed(0); }

  function variantById(id) { return PRODUCT.variants.find((v) => v.id === id); }

  function cartTotal() {
    return cartState.items.reduce((sum, it) => sum + it.price * it.qty, 0);
  }

  function cartCount() {
    return cartState.items.reduce((sum, it) => sum + it.qty, 0);
  }

  /* ---------------- Cart UI ---------------- */
  function renderCart() {
    const drawer = $('#cart-drawer');
    if (!drawer) return;
    const body = $('#cart-body', drawer);
    const total = cartTotal();
    const count = cartCount();
    const remaining = Math.max(0, cartState.freeShipMin - total);
    const pct = Math.min(100, Math.round((total / cartState.freeShipMin) * 100));

    // Update header bubble
    const bubble = $('#cart-count');
    if (bubble) {
      bubble.textContent = count;
      bubble.classList.toggle('has-items', count > 0);
    }

    if (count === 0) {
      body.innerHTML = `
        <div class="cart-empty">
          <h4 style="margin-top: 8px;">No carrier in your cart.</h4>
          <p>Choose a colorway to begin. Check the wearing guide and delivery times before you order.</p>
          <a href="/collections/carriers" class="btn btn-primary">Shop the Carrier</a>
        </div>`;
      $('#cart-footer').style.display = 'none';
      return;
    }

    $('#cart-footer').style.display = 'block';

    const progressMsg = remaining > 0
      ? `${money(remaining)} from free AU shipping`
      : 'Free AU shipping unlocked';

    let html = `
      <div class="cart-progress">
        <div class="cart-progress-bar"><div class="cart-progress-fill" style="width:${pct}%"></div></div>
        <div class="cart-progress-msg">${progressMsg}</div>
      </div>
    `;

    cartState.items.forEach((it, idx) => {
      const v = variantById(it.variantId) || { name: it.variantId, swatch: '#C7B299' };
      html += `
        <div class="cart-item" data-idx="${idx}">
          <div class="cart-item-img" style="background: linear-gradient(135deg, ${v.swatch} 50%, var(--bg-warm) 50%);"></div>
          <div>
            <div class="cart-item-name">${it.name}</div>
            <div class="cart-item-variant">${v.name}</div>
            <div class="cart-qty">
              <button data-act="dec" data-idx="${idx}">−</button>
              <span>${it.qty}</span>
              <button data-act="inc" data-idx="${idx}">+</button>
            </div>
          </div>
          <div class="cart-item-price">${money(it.price * it.qty)}</div>
        </div>`;
    });

    // Upsells (pairs well)
    html += `
      <div class="cart-upsell-section">
        <h5>Pairs well with</h5>
        ${UPSELLS.map((u) => `
          <div class="cart-upsell-row">
            <div class="cart-upsell-img">${u.img ? `<img src="${u.img}" alt="${u.name}" style="width:100%;height:100%;object-fit:cover;display:block;border-radius:var(--radius-xs);" />` : ''}</div>
            <div class="cart-upsell-info">
              <div class="cart-upsell-name">${u.name}</div>
              <div class="cart-upsell-price">${u.price === 0 ? 'Included free' : money(u.price)}</div>
            </div>
            <button class="cart-upsell-add" data-upsell="${u.id}">Add</button>
          </div>`).join('')}
      </div>`;

    body.innerHTML = html;

    // Wire qty buttons
    $$('.cart-qty button', body).forEach((b) => {
      b.addEventListener('click', () => {
        const idx = Number(b.dataset.idx);
        const it = cartState.items[idx];
        if (!it) return;
        if (b.dataset.act === 'inc') it.qty++;
        else it.qty = Math.max(0, it.qty - 1);
        if (it.qty === 0) cartState.items.splice(idx, 1);
        renderCart();
      });
    });

    // Wire upsell adds
    $$('.cart-upsell-add', body).forEach((b) => {
      b.addEventListener('click', () => {
        const u = UPSELLS.find((x) => x.id === b.dataset.upsell);
        if (!u) return;
        if (cartState.items.find((i) => i.id === u.id)) return;
        cartState.items.push({ id: u.id, name: u.name, variantId: 'addon', price: u.price, qty: 1 });
        renderCart();
      });
    });

    // Footer total
    $('#cart-total-amount').textContent = money(total) + ' AUD';
  }

  function openDrawer(id) {
    const d = $('#' + id);
    if (!d) return;
    d.classList.add('open');
    $('.drawer-backdrop').classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(id) {
    const d = $('#' + id);
    if (!d) return;
    d.classList.remove('open');
    if (!$$('.drawer.open').length) {
      $('.drawer-backdrop').classList.remove('open');
      document.body.style.overflow = '';
    }
  }
  function closeAllDrawers() {
    $$('.drawer.open').forEach((d) => d.classList.remove('open'));
    $('.drawer-backdrop').classList.remove('open');
    document.body.style.overflow = '';
  }

  /* ---------------- ATC ---------------- */
  window.addToCart = function (variantId, qty) {
    qty = qty || 1;
    const v = variantById(variantId) || PRODUCT.variants[0];
    const existing = cartState.items.find((i) => i.id === PRODUCT.id && i.variantId === v.id);
    if (existing) existing.qty += qty;
    else cartState.items.push({ id: PRODUCT.id, name: PRODUCT.name, variantId: v.id, price: PRODUCT.price, qty });
    renderCart();
    openDrawer('cart-drawer');
  };

  /* ---------------- PDP swatch + qty ---------------- */
  function initPDP() {
    // On Shopify, the IIFE-2 adapter handles swatch / qty / ATC via data-bb-* attrs.
    // Skip the static-preview handlers so they don't fight the real form submit.
    if (window.BabyBondeTheme) return;
    const swatches = $$('.pdp-swatch');
    if (!swatches.length) return;

    let selected = swatches[0].dataset.variant;
    swatches.forEach((s) => {
      s.addEventListener('click', () => {
        swatches.forEach((x) => x.classList.remove('active'));
        s.classList.add('active');
        selected = s.dataset.variant;
        const v = variantById(selected);
        const label = $('.pdp-variant-label .selected');
        if (label) label.textContent = v.name;
        // Update main image bg as a visual stand-in
        const main = $('.pdp-main-bg');
        if (main) main.style.setProperty('--swatch', v.swatch);
      });
    });

    // Qty
    let qty = 1;
    const qtyDisplay = $('.pdp-qty span');
    $$('.pdp-qty button').forEach((b) => {
      b.addEventListener('click', () => {
        if (b.dataset.act === 'inc') qty++;
        else qty = Math.max(1, qty - 1);
        qtyDisplay.textContent = qty;
      });
    });

    // ATC
    const atc = $('.pdp-atc');
    if (atc) atc.addEventListener('click', () => window.addToCart(selected, qty));

    // Gallery thumbs — swap main image
    const mainImg = $('#pdp-main-img');
    $$('.pdp-thumb').forEach((t) => {
      t.addEventListener('click', () => {
        $$('.pdp-thumb').forEach((x) => x.classList.remove('active'));
        t.classList.add('active');
        const src = t.dataset.img;
        if (src && mainImg) mainImg.src = src;
      });
    });
  }

  /* ---------------- Sticky ATC on PDP ---------------- */
  function initStickyATC() {
    const sticky = $('.sticky-atc');
    const buybox = $('.pdp-buy-box');
    if (!sticky || !buybox) return;
    window.addEventListener('scroll', () => {
      const rect = buybox.getBoundingClientRect();
      sticky.classList.toggle('in', rect.bottom < 100);
    });
  }

  /* ---------------- Carousel dots (mobile-only — Velora pattern) ---------------- */
  function setupCarousels() {
    if (!('IntersectionObserver' in window)) return;
    const shells = $$('.carousel-shell');
    shells.forEach((shell) => {
      const track = shell.querySelector('.review-grid, .pt-grid, .how-grid, .colorway-grid, .card-carousel');
      if (!track) return;
      const cards = Array.from(track.children);
      if (cards.length < 2) return;

      let dots = shell.querySelector('.carousel-dots');
      if (!dots) {
        dots = document.createElement('div');
        dots.className = 'carousel-dots';
        shell.appendChild(dots);
      }
      dots.innerHTML = '';
      const dotEls = cards.map((_, i) => {
        const b = document.createElement('button');
        b.className = 'dot' + (i === 0 ? ' active' : '');
        b.setAttribute('aria-label', 'Slide ' + (i + 1));
        b.addEventListener('click', () => {
          cards[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        dots.appendChild(b);
        return b;
      });

      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              const idx = cards.indexOf(e.target);
              if (idx >= 0) {
                dotEls.forEach((d) => d.classList.remove('active'));
                dotEls[idx].classList.add('active');
              }
            }
          });
        },
        { root: track, threshold: 0.5 }
      );
      cards.forEach((c) => io.observe(c));
    });
  }

  /* ---------------- Scroll reveal ---------------- */
  function initReveal() {
    const els = $$('.reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach((el) => el.classList.add('in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach((el) => io.observe(el));
  }

  /* ---------------- Market picker (AU primary, 5 markets) ---------------- */
  function initMarketPicker() {
    const trigger = $('#market-trigger');
    if (!trigger) return;
    const marketData = document.querySelector('[data-bb-markets]');
    if (!marketData) return;
    const MARKETS = JSON.parse(marketData.textContent);

    trigger.addEventListener('click', () => {
      const html = `
        <div class="drawer-header"><div class="title">Choose Market</div><button class="drawer-close" data-close="market-drawer"><svg viewBox="0 0 24 24"><path d="M6 6 L18 18 M6 18 L18 6"/></svg></button></div>
        <div class="drawer-body">
          ${MARKETS.map((mk) => `
            <button class="menu-list-item" data-market="${mk.code}" style="display:flex;justify-content:space-between;align-items:center;padding:18px 0;border-bottom:1px solid var(--hairline);width:100%;text-align:left;">
              <span style="font-weight:600;font-size:1.05rem;">${mk.label}</span>
              <span style="font-family:'JetBrains Mono',monospace;font-size:0.75rem;text-transform:uppercase;letter-spacing:0.06em;color:var(--ink-mute);">${mk.code} · ${mk.currency}</span>
            </button>`).join('')}
        </div>`;
      const d = $('#market-drawer');
      d.innerHTML = html;
      openDrawer('market-drawer');

      $$('button[data-market]', d).forEach((b) => {
        b.addEventListener('click', () => {
          closeDrawer('market-drawer');
        });
      });
      $$('[data-close]', d).forEach((b) => b.addEventListener('click', () => closeDrawer(b.dataset.close)));
    });
  }

  /* ---------------- Init ---------------- */
  document.addEventListener('DOMContentLoaded', () => {
    // Drawer triggers
    $$('[data-open]').forEach((b) => b.addEventListener('click', () => openDrawer(b.dataset.open)));
    $$('[data-close]').forEach((b) => b.addEventListener('click', () => closeDrawer(b.dataset.close)));
    const bd = $('.drawer-backdrop');
    if (bd) bd.addEventListener('click', closeAllDrawers);

    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAllDrawers(); });

    if (!window.BabyBondeTheme) renderCart();
    initPDP();
    initStickyATC();
    initReveal();
    initMarketPicker();
    setupCarousels();
  });
})();


/* ============================================================
   SHOPIFY AJAX ADAPTER — auto-engages when running on Shopify
   In static preview, window.BabyBondeTheme is undefined and the
   original local Cart object above remains in charge.
   ============================================================ */
(function () {
  if (!window.BabyBondeTheme || !window.BabyBondeTheme.routes) return;

  var routes = window.BabyBondeTheme.routes;
  var strings = window.BabyBondeTheme.strings || {};
  var moneyFormat = window.BabyBondeTheme.moneyFormat || '${{amount}}';

  function fmt(cents, currency) {
    try { return new Intl.NumberFormat('en', { style: 'currency', currency: currency || 'AUD', currencyDisplay: 'narrowSymbol' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }

  function escapeText(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function showCartError() {
    var el = document.querySelector('[data-bb-cart-error]');
    if (el) { el.textContent = strings.cartError; el.hidden = false; }
  }

  function fetchJSON(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ 'Content-Type': 'application/json', 'Accept': 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function getCart() {
    return fetchJSON(routes.cart + '.js');
  }

  function addItem(variantId, qty) {
    return fetchJSON(routes.cartAdd + '.js', {
      method: 'POST',
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    });
  }

  function changeItem(key, qty) {
    return fetchJSON(routes.cartChange + '.js', {
      method: 'POST',
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }

  function openCart() {
    var d = document.getElementById('cart-drawer');
    var bd = document.querySelector('.drawer-backdrop');
    if (d) d.classList.add('open');
    if (bd) bd.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function readCartConfig() {
    var el = document.querySelector('[data-bb-cart-config]');
    if (!el) return { freeShipMin: 8000, currency: 'AUD', upsells: [] };
    try {
      var cfg = JSON.parse(el.textContent);
      cfg.freeShipMin = (cfg.freeShipMin || 80) * 100;
      return cfg;
    } catch (e) {
      return { freeShipMin: 8000, currency: 'AUD', upsells: [] };
    }
  }

  function renderShopifyCart(cart) {
    document.dispatchEvent(new CustomEvent('babo:cart-rendered', { detail: cart }));
    var body = document.getElementById('cart-body');
    var footer = document.getElementById('cart-footer');
    var bubble = document.getElementById('cart-count');
    var totalEl = document.getElementById('cart-total-amount');
    if (!body) return;
    var error = document.querySelector('[data-bb-cart-error]');
    if (error) error.hidden = true;

    var cfg = readCartConfig();
    if (cfg.clearancePreview && cfg.currency === cart.currency) {
      cart = JSON.parse(JSON.stringify(cart));
      cart.items.forEach(function(item) {
        if (Object.prototype.hasOwnProperty.call(cfg.referencePrices || {}, String(item.variant_id || item.id))) {
          var unit = Math.round((item.original_line_price / item.quantity) * 0.8);
          item.original_line_price = unit * item.quantity;
          item.final_line_price = item.original_line_price;
          item.line_level_discount_allocations = [];
        }
      });
      cart.total_price = cart.items.reduce(function(sum,item){ return sum + Number(item.final_line_price); }, 0);
      cart.items_subtotal_price = cart.total_price;
      cart.cart_level_discount_applications = [];
      cart.total_discount = 0;
    }

    if (bubble) {
      bubble.textContent = cart.item_count;
      bubble.classList.toggle('has-items', cart.item_count > 0);
    }

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty">' +
        '<h4 style="margin-top:8px;">No carrier in your cart.</h4>' +
        '<p>Choose a colorway to begin. Check the wearing guide and delivery times before you order.</p>' +
        '<a href="' + routes.root + 'collections/all" class="btn btn-primary">Shop the Carrier</a>' +
        '</div>';
      if (footer) footer.style.display = 'none';
      return;
    }

    if (footer) footer.style.display = 'block';

    var remaining = Math.max(0, cfg.freeShipMin - cart.total_price);
    var pct = Math.min(100, Math.round((cart.total_price / cfg.freeShipMin) * 100));
    var progressMsg = 'Free shipping to supported destinations';

    var html = '';

    cart.items.forEach(function (item) {
      var reference = cfg.currency === cart.currency ? Number((cfg.referencePrices || {})[String(item.variant_id || item.id)]) * item.quantity : 0;
      var original = Number(item.original_line_price);
      var lineFinal = Number(item.final_line_price);
      var seasonal = reference > original;
      var priceHtml = (seasonal ? '<s class="babo-cart-reference">' + fmt(reference, cart.currency) + '</s>' : '') +
        (original > lineFinal ? '<s class="babo-cart-reference">' + fmt(original, cart.currency) + '</s>' : '') +
        '<strong class="' + (seasonal || original > lineFinal ? 'babo-cart-sale' : '') + '">' + fmt(lineFinal, cart.currency) + '</strong>' +
        (seasonal && original === lineFinal ? '<small>' + escapeText(cfg.labels.seasonal) + '</small>' : '') +
        (item.line_level_discount_allocations || []).map(function (allocation) {
          return '<small class="babo-cart-discount">' + escapeText(allocation.discount_application.title) + ' −' + fmt(allocation.amount, cart.currency) + '</small>';
        }).join('');
      html += '<div class="cart-item" data-key="' + item.key + '">' +
        '<div class="cart-item-img">' +
          (item.image ? '<img src="' + escapeText(item.image) + (item.image.indexOf('?') === -1 ? '?' : '&') + 'width=200" alt="' + escapeText(item.title) + '" style="width:100%;height:100%;object-fit:cover;display:block;">' : '') +
        '</div>' +
        '<div>' +
          '<div class="cart-item-name">' + escapeText(item.product_title) + '</div>' +
          '<div class="cart-item-variant">' + escapeText(item.variant_title === 'Default Title' ? '' : item.variant_title) + '</div>' +
          '<div class="cart-qty">' +
            '<button type="button" aria-label="' + escapeText(strings.decrease + ' ' + item.product_title) + '" data-act="dec" data-key="' + item.key + '">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" aria-label="' + escapeText(strings.increase + ' ' + item.product_title) + '" data-act="inc" data-key="' + item.key + '">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="cart-item-price babo-cart-prices">' + priceHtml + '</div>' +
      '</div>';
    });

    // Upsells from data-attr config
    if (cfg.upsells && cfg.upsells.length) {
      html += '<div class="cart-upsell-section"><h5>Pairs well with</h5>';
      cfg.upsells.forEach(function (u) {
        html += '<div class="cart-upsell-row">' +
          '<div class="cart-upsell-img">' + (u.img ? '<img src="' + u.img + '" alt="' + u.name + '" style="width:100%;height:100%;object-fit:cover;display:block;border-radius:var(--radius-xs);">' : '') + '</div>' +
          '<div class="cart-upsell-info">' +
            '<div class="cart-upsell-name">' + u.name + '</div>' +
            '<div class="cart-upsell-price">' + (u.price === 0 ? 'Included free' : '$' + u.price) + '</div>' +
          '</div>' +
          '<button class="cart-upsell-add" data-upsell-handle="' + u.id + '">Add</button>' +
        '</div>';
      });
      html += '</div>';
    }

    body.innerHTML = html;
    if (totalEl) totalEl.textContent = fmt(cart.total_price, cart.currency) + ' ' + cart.currency;
    var discountsEl = document.querySelector('[data-bb-cart-discounts]');
    var cartDiscounts = (cart.cart_level_discount_applications || []).filter(function (discount) {
      return discount.title && Number(discount.total_allocated_amount) > 0;
    });
    var totalLabel = document.querySelector('[data-bb-total-label]');
    if (totalLabel) totalLabel.textContent = cart.total_discount > 0 ? cfg.labels.discountedTotal : cfg.labels.total;
    if (discountsEl) {
      discountsEl.innerHTML = (cartDiscounts.length ? '<div class="babo-cart-breakdown-row"><span>' + escapeText(cfg.labels.subtotal) + '</span><span>' + fmt(cart.items_subtotal_price, cart.currency) + '</span></div>' : '') + cartDiscounts.map(function (discount) {
        return '<div class="babo-cart-breakdown-row babo-cart-discount"><span>' + escapeText(discount.title) + '</span><span>−' + fmt(discount.total_allocated_amount, cart.currency) + '</span></div>';
      }).join('');
    }

    // Wire qty buttons
    Array.prototype.forEach.call(body.querySelectorAll('.cart-qty button'), function (b) {
      b.addEventListener('click', function () {
        var buttons = body.querySelectorAll('.cart-qty button');
        Array.prototype.forEach.call(buttons, function (button) { button.disabled = true; });
        var key = b.dataset.key;
        var item = cart.items.find(function (i) { return i.key === key; });
        var newQty = b.dataset.act === 'inc' ? item.quantity + 1 : Math.max(0, item.quantity - 1);
        changeItem(key, newQty).then(getCart).then(renderShopifyCart).catch(showCartError).finally(function () {
          Array.prototype.forEach.call(buttons, function (button) { button.disabled = false; });
        });
      });
    });
  }

  // Handle on the form so Shopify observes preventDefault before the event bubbles.
  // A document-level handler can cause both form and Ajax add-to-cart analytics.
  function onProductFormSubmit(e) {
    var form = e.currentTarget;
    e.preventDefault();
    if (form.dataset.bbPending === 'true') return;
    var submit = form.querySelector('button[type="submit"]');
    if (submit && submit.disabled) return;
    var error = form.querySelector('[data-bb-form-error]');
    if (error) error.hidden = true;
    var buttons = [submit].concat(Array.prototype.slice.call(document.querySelectorAll('[data-bb-sticky-atc]'))).filter(Boolean);
    var labels = buttons.map(function (button) { return button.textContent; });
    form.dataset.bbPending = 'true';
    buttons.forEach(function (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = strings.adding; });

    var fd = new FormData(form);
    var variantId = fd.get('id');
    var qty = Number(fd.get('quantity') || 1);

    addItem(variantId, qty)
      .then(getCart)
      .then(function (cart) {
        renderShopifyCart(cart);
        openCart();
      })
      .catch(function () { if (error) { error.textContent = strings.addError; error.hidden = false; } })
      .finally(function () {
        form.dataset.bbPending = 'false';
        buttons.forEach(function (button, i) { button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = labels[i]; });
      });
  }

  function bindProductForms(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-bb-product-form]'), function (form) {
      if (form.dataset.bbSubmitBound) return;
      form.dataset.bbSubmitBound = 'true';
      form.addEventListener('submit', onProductFormSubmit);
    });
  }
  bindProductForms(document);
  document.addEventListener('shopify:section:load', function (e) {
    bindProductForms(e.target);
  });

  // Variant swatch click — swap variant input
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.pdp-swatch[data-variant-id]');
    if (!swatch) return;
    var form = swatch.closest('[data-bb-product-form]') || document.querySelector('[data-bb-product-form]');
    if (!form) return;
    Array.prototype.forEach.call(document.querySelectorAll('.pdp-swatch'), function (s) { s.classList.remove('active'); });
    swatch.classList.add('active');
    var input = form.querySelector('[data-bb-variant-input]');
    if (input) input.value = swatch.dataset.variantId;
    var label = document.querySelector('[data-bb-variant-label]');
    if (label) label.textContent = swatch.dataset.variantTitle;
    var price = document.querySelector('[data-bb-price]');
    if (price && swatch.dataset.variantPrice) price.textContent = swatch.dataset.variantPrice;
  });

  // Qty +/- on PDP
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pdp-qty button[data-act]');
    if (!btn) return;
    var form = btn.closest('[data-bb-product-form]') || document.querySelector('[data-bb-product-form]');
    if (!form) return;
    var input = form.querySelector('[data-bb-qty-input]');
    var span = form.querySelector('[data-bb-qty]');
    var current = Number((input && input.value) || 1);
    var next = btn.dataset.act === 'inc' ? current + 1 : Math.max(1, current - 1);
    if (input) input.value = next;
    if (span) span.textContent = next;
  });

  // Sticky ATC button — trigger main form submit
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bb-sticky-atc]');
    if (!btn) return;
    e.preventDefault();
    var form = document.querySelector('[data-bb-product-form]');
    if (form && form.dataset.bbPending !== 'true') form.requestSubmit();
  });

  // Initial render
  document.addEventListener('DOMContentLoaded', function () {
    getCart().then(renderShopifyCart).catch(function (err) { console.warn('[BB cart] initial load failed', err); });
  });

  // Override the static window.addToCart hook
  window.addToCart = function (variantId, qty) {
    return addItem(variantId, qty).then(getCart).then(function (cart) {
      renderShopifyCart(cart);
      openCart();
    });
  };

  // Expose the renderer so section scripts (cart-drawer gift enforcement) can re-render after their own cart writes
  window.bbRenderCart = renderShopifyCart;
})();

(function () {
  function bindGalleries(root) {
    root.querySelectorAll('[data-babo-gallery]').forEach(function (gallery) {
      if (gallery.dataset.bound) return;
      gallery.dataset.bound = 'true';
      const track = gallery.querySelector('.babo-gallery-track');
      const slides = Array.from(track.children);
      const previous = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');
      const count = gallery.querySelector('[data-gallery-index]');
      if (!next) return;
      let index = 0;
      function update() {
        index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        count.textContent = index + 1;
        previous.disabled = index === 0;
        next.disabled = index === slides.length - 1;
      }
      function move(step) {
        track.scrollTo({ left: Math.max(0, Math.min(slides.length - 1, index + step)) * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      previous.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); move(e.key === 'ArrowRight' ? 1 : -1); }
      });
      new ResizeObserver(update).observe(track);
      update();
    });
  }
  bindGalleries(document);
  document.addEventListener('shopify:section:load', function (e) { bindGalleries(e.target); });
})();
